import { Children, isValidElement, ReactNode } from 'react';
import { Grid2 } from '@mui/material';
import { SortButton } from 'framework/list';
import { Box } from '@mui/system';
import { getLabel } from 'framework/utils';

interface LeavesGridHeaderProps {
  children: ReactNode;
  isShowHeader?: boolean;
  expandable?: boolean;
}

const LeavesGridHeader = ({ children, isShowHeader = true, expandable = false }: LeavesGridHeaderProps) => {
  if (!isShowHeader) return null;

  const renderHeaderCell = (child: ReactNode, index: number) => {
    if (!isValidElement(child)) return null;

    const { source, sortSource, label, isSortable, size = 2 } = child.props;
    const headerText = getLabel(label, source);
    const key = `${label || source || index}`;

    if (index === 0 && expandable) {
      return (
        <Grid2 key={key} size={size} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ pl: 3 }} />
          {isSortable ? <SortButton source={sortSource ?? source} label={headerText} /> : <>{headerText}</>}
        </Grid2>
      );
    }

    if (index === 0) {
      return (
        <Grid2 key={key} size={size} sx={{ paddingLeft: 4 }}>
          {isSortable ? <SortButton source={sortSource ?? source} label={headerText} /> : <>{headerText}</>}
        </Grid2>
      );
    }

    return (
      <Grid2 key={key} size={size}>
        {isSortable ? <SortButton source={sortSource ?? source} label={headerText} /> : <>{headerText}</>}
      </Grid2>
    );
  };

  return (
    <Grid2
      container
      wrap="nowrap"
      sx={{
        px: 2,
        py: 1,
        width: '100%',
        color: 'primary.main',
        boxSizing: 'border-box',
        justifyContent: 'space-between',
        fontSize: '12px',
      }}
    >
      {Children.toArray(children).map(renderHeaderCell)}
    </Grid2>
  );
};

export default LeavesGridHeader;
